import axios from "axios";

/**
 * #22 (ESERV2-1430) — "Add and link": one action that creates the local
 * inventory item for a Heritage part the company does not carry and links it
 * to the vendor. The backend endpoint does both atomically and returns the new
 * item id (routes/company/heritage/index.ts, create-inventory-item — the same
 * flow the auto-link screen's create path has always used).
 */

export type AddAndLinkHeritagePart = {
	heritage_part_number: string;
	description?: string | null;
};

export async function createAndLinkHeritagePart(
	vendorId: number,
	part: AddAndLinkHeritagePart
): Promise<number | null> {
	const res = await axios.post(
		`${process.env.REACT_APP_SERVER_URL}/api/v1/company/heritage/create-inventory-item`,
		{
			vendorId,
			heritagePart: {
				heritage_part_number: part.heritage_part_number,
				description: part.description ?? null,
			},
		}
	);
	return res.data?.itemId ?? null;
}
